import { NetworkStatus } from '@cbridge-utils/network';
import { ICoverageRuleStore } from './coverageRule.interface';

export const coverageRuleInitialState: ICoverageRuleStore = {
  ruleSetId: undefined,
  list: [],
  networkStatus: NetworkStatus.None,
};
